import DatePickerLocale from 'rmc-date-picker/es/locale/zh_CN';
export default DatePickerLocale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/date-picker-view/locale/zh_CN.js
// module id = 227
// module chunks = 0